export default {"src":"/_next/static/media/box-top.8174d9f7.svg","height":74,"width":210,"blurWidth":0,"blurHeight":0};